angular.module('psModule').controller('ProfilePageCtrl',
    function($scope, $rootScope, $uibModal, $translate){

    $scope.individualId = individualId();
    $scope.lang = () => $translate.use();
    console.log("Profile page, individualId", $scope.individualId, "lang", $scope.lang());

    function individualId() {
        return $scope.$root.config && $scope.$root.config.individualId || null;
    }

 });
